import { SupabaseClient } from "@supabase/supabase-js";
import { logException, SentryFeatureTags } from "@punchup/sentry";
import { Database } from "../../supabase.types";

/**
 * Emails for the staff who wrote, edited or verified a case, keyed by user id.
 * Needs the service-role client (auth admin API). A user who no longer exists
 * maps to null rather than failing the page that shows the case.
 */
export async function getSupportPeopleEmails(
  supabase: SupabaseClient<Database>,
  userIds: (string | null)[]
): Promise<Map<string, string | null>> {
  const unique = [
    ...new Set(userIds.filter((id): id is string => Boolean(id))),
  ];

  const entries = await Promise.all(
    unique.map(async (userId): Promise<[string, string | null]> => {
      try {
        const { data, error } = await supabase.auth.admin.getUserById(userId);
        if (error || !data.user) return [userId, null];
        return [userId, data.user.email ?? null];
      } catch (err) {
        logException(err, {
          tags: {
            feature: SentryFeatureTags.SupportAssistant,
            action: "getSupportPeopleEmails",
          },
          extra: { userId },
        });
        return [userId, null];
      }
    })
  );

  return new Map(entries);
}
